














// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { BootstrapFormError } from '../FormError'

import { BootstrapCheckProps } from './Check.contracts'
import { bootstrapCheckProps, useBootstrapCheck } from './Check.hooks'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const BootstrapCheck = defineComponent({
  name: 'BootstrapCheck',
  components: { BootstrapFormError },
  props: bootstrapCheckProps,
  emits: ['update:model'],

  setup (props: BootstrapCheckProps, ctx: SetupContext) {
    const { checked, checkType, component, validationClass } = useBootstrapCheck(props, ctx)
    return { checked, checkType, component, validationClass }
  }
})

export default BootstrapCheck
